import { Grid } from "@aircall/tractor";
import styled from "@xstyled/styled-components";

export const Container = styled(Grid).attrs({
  pb: "8px",
  rowGap: "24px",
  alignItems: "center",
})`
  transition: all 0.7s;
`;
